import React from "react"

import {
  FiInfo, FiAlertCircle, FiAlertTriangle, FiBell,
} from "react-icons/fi"
import { message } from "./Message.module.scss"

const Message = ({
  children,
  type = "default",
  warning,
  notice,
  danger,
  tip,
  size,
  noMargin = false,
}) => {
  if (notice === "") type = "notice"
  if (danger === "") type = "danger"
  if (warning === "") type = "warning"
  if (tip === "") type = "tip"

  return (
    <div
      className={message}
      data-type={type}
      data-size={size}
      data-margin={!noMargin}
      data-message
    >
      {type === "default" && <FiInfo />}
      {type === "notice" && <FiBell />}
      {type === "tip" && <FiBell />}
      {type === "warning" && <FiAlertCircle />}
      {type === "danger" && <FiAlertTriangle />}
      {children}
    </div>
  )
}

export default Message
